/*
 *  Author: DL
 *  Date: 2020-12-03 15:45:32
 *  Email: dunaliang@fengmap.com
 *  LastEditTime: 2020-12-18 13:53:28
 *  LastEditors: DL
 *  Description: 搜索导航
 *  Copyright: Copyright 2014 - 2020, FengMap, Ltd. All rights reserved.
 */

import React, { useRef, useCallback, useLayoutEffect } from 'react';
import classnames from 'classnames';
import { Button, Icon } from 'ui';
import Input from './Input';
import styles from './index.less';

export default function(props) {
    const { startDefaultValue = '', endDefaultValue = '' } = props;
    const { onBackClick = () => {}, onInputChange = () => {}, onInputFocus = () => {}, onInputToggle = () => {}, onInputClick = () => {} } = props;

    const startInput = useRef(null);
    const endInput = useRef(null);

    const handleChangeInput = useCallback(
        event => {
            const keyword = event.target.value;
            onInputChange(keyword);
        },
        [onInputChange],
    );

    const handleInputFocus = useCallback(
        event => {
            const field = event.target.dataset.field;
            onInputFocus(field);
        },
        [onInputFocus],
    );

    useLayoutEffect(() => {
        const startInputElement = startInput.current;
        const endInputElement = endInput.current;

        setTimeout(() => {
            if (startInputElement.value) {
                endInputElement.focus();
            } else {
                startInputElement.focus();
            }
        }, 500);

        startInputElement.addEventListener('focus', handleInputFocus);
        endInputElement.addEventListener('focus', handleInputFocus);

        return () => {
            startInputElement.removeEventListener('focus', handleInputFocus);
            endInputElement.removeEventListener('focus', handleInputFocus);
        };
    }, [handleInputFocus]);

    return (
        <div className={styles.wrapper}>
            <Button onClick={onBackClick}>
                <Icon className="iconBack" />
            </Button>
            <div className={styles.inputWrapper}>
                <div className={styles.icon}>
                    <span className={classnames([styles.circle, styles.start])}></span>
                    <span className={styles.line}>
                        <span></span>
                        <span></span>
                        <span></span>
                    </span>
                    <span className={classnames([styles.circle, styles.end])}></span>
                </div>
                <div className={styles.content}>
                    <Input defaultValue={startDefaultValue} data-field="start" placeholder="请输入起点" ref={startInput} onChange={handleChangeInput} onClick={onInputClick} text="起点" />
                    <Input defaultValue={endDefaultValue} data-field="end" placeholder="请输入终点" ref={endInput} onChange={handleChangeInput} onClick={onInputClick} text="终点" />
                </div>
                <div className={styles.toggle} onClick={onInputToggle}>
                    <Icon className="iconqiehuan1" />
                </div>
            </div>
        </div>
    );
}
